import React from 'react';
//import ReactDOM from "react-dom/client";
import AuthService from "../services/auth-service";
import { Navigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";

class Logout extends React.Component {
  constructor(props) {    
    super(props); 
    this.state = { 
      prova: 1,
    };    
    AuthService.logout()    
  }
  componentDidMount() {
    this.props.logoutHandler()
  }
  render() {    
    return (
      <Navigate to="/" replace={true} />
    )
  }
}

export default Logout;
